module.exports = __webpack_public_path__ + "img/envia.72a0a406.svg";